import { useQuery } from '@tanstack/react-query';

import { createOrderV2Client } from '../api/client';
import { orderV2QueryKeys } from '../api/queryKeys';
import { SkillCategoryListItem } from '../api/types';

const useSkillCategories = (billingAccountId: number | null) => {
  const enabled = billingAccountId != null;
  const query = useQuery<SkillCategoryListItem[]>({
    queryKey: enabled
      ? orderV2QueryKeys.skillCategories(billingAccountId)
      : ['orders_v2', 'skill_categories', 'disabled'],
    queryFn: () =>
      createOrderV2Client
        .listSkillCategories(billingAccountId as number)
        .then((result) => result || []),
    enabled,
  });

  return { skillCategories: query.data ?? [] };
};

export default useSkillCategories;
